import './FeaturesSection.css';

const features = [
  {
    icon: '🤖',
    title: 'Create Multiple Agents',
    description: 'Deploy multiple OpenClaw instances, each with its own environment. Build a team of AI agents working for you.',
  },
  {
    icon: '💤',
    title: 'Scale to Zero',
    description: 'Auto-suspend when idle and resume on demand. Pay only for active time and keep costs controlled.',
  },
  {
    icon: '👥',
    title: 'Share Your Bot',
    description: 'Invite-based team collaboration is coming soon.',
    comingSoon: true,
  },
  {
    icon: '🔒',
    title: 'Secure by Design',
    description: 'Request validation layer protects your cloud agent from unauthorized access.',
  },
  {
    icon: '🧠',
    title: 'Multi-Model Support',
    description: 'Integrate with Kimi, MiniMax, Qwen, GLM and more. Use your favorite AI.',
  },
  {
    icon: '💬',
    title: 'Bot Integrations',
    description: 'Connect your agent to Telegram, Discord, Feishu and more. Chat from anywhere.',
  },
  {
    icon: '🔐',
    title: 'Private & Isolated',
    description: 'Each instance runs in isolated environment with persistent storage. Your data stays yours.',
  },
  {
    icon: '📁',
    title: 'File Workspace',
    description: 'Cloud file manager for your agent\'s workspace. Manage files with ease.',
    comingSoon: true,
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="landing-section features-section">
      <div className="landing-section-inner">
        <div className="section-header animate-on-scroll">
          <h2 className="section-title">Everything You Need</h2>
          <p className="section-subtitle">
            Powerful features that make running OpenClaw in the cloud effortless
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className={`feature-card animate-on-scroll animate-delay-${(index % 4) + 1}`}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">
                {feature.title}
                {feature.comingSoon && (
                  <span className="coming-soon-badge">Soon</span>
                )}
              </h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
